import {createGameserverHeaderUIInstances, GameserverHeaderUI} from './headerUI';
import {Gamecloud} from '../../gamecloud';
import Axios from 'axios';
import {PageType} from "../../interface";

class GameserverHeader extends Gamecloud {
    private playerInterval;

    public constructor(private ui: GameserverHeaderUI) {
        super();
        this.ui.setSticky();

        this.playerInterval = window.setInterval(() => {
            this.fetchPlayers()
        }, 15000);
    }

    private destroyTimeout() {
        window.clearInterval(this.playerInterval);
    }


    private fetchPlayers() {
        const apiUrl: string = window.gamesServerApiQuery;
        Axios.get(apiUrl + this.ui.getServerId()).then((response) => {
            this.ui.renderMeta(response.data, this.destroyTimeout.bind(this));
        })
    }
}

export function initGameserverHeader() {
    if (window.pageType === PageType.Game) {
        const instances: GameserverHeaderUI[] = createGameserverHeaderUIInstances();
        return instances.map((ui: GameserverHeaderUI) => {
            new GameserverHeader(ui);
        });
    }
}
